



















































import _ from "lodash";
import "devextreme/dist/css/dx.light.css";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { Maintenancejob, PaymentDetail, Property } from "@/models";
import Photos from "@/components/photo/Photos.vue";
import { DxDateBox } from "devextreme-vue/date-box";

@Component({
  components: {
    Photos,
    DxDateBox,
  },
})
export default class PaymentDetails extends Vue {
  @Prop({ default: false }) public showsidebar: boolean;

  @Getter("maintenancejobs/hasUnsavedChanges")
  public hasUnsavedChanges: boolean;
  @Getter("auth/isBaseUser") public isBaseUser: boolean;
  @Getter("auth/isAdministrator") public isAdministrator: boolean;
  @Getter("maintenancejobs/current") public maintenancejob: Maintenancejob;
  @Getter("maintenancejob/list") public list: Property[];

  @Getter("maintenancejobs/list") public maintenancejoblist: Maintenancejob[];

  @Mutation("maintenancejobs/setCurrent")
  public setCurrent: (maintenancejob: Maintenancejob) => void;
  @Action("maintenancejobs/getMaintenancejob")
  public getMaintenancejob: (id: string) => Promise<Maintenancejob>;
  @Action("maintenancejobs/setMaintenancejobDeep")
  public setMaintenancejobDeep: (payload: {
    path: string;
    data: any;
  }) => Promise<any>;
  get paymentdetails(): PaymentDetail[] {
    return this.maintenancejob.paymentdetails;
  }
  set paymentdetails(data: PaymentDetail[]) {
    this.setMaintenancejobDeep({ path: "paymentdetails", data });
  }
  /**
   * Add New Payment
   */
  public addNewPayment(): void {
    this.paymentdetails = this.paymentdetails.concat([new PaymentDetail()]);
  }

  /**
   * Remove Payment
   */
  public removePayment(index: number): void {
    this.$onecentral
      .confirmPrompt()
      .then(
        () =>
          (this.paymentdetails = this.$onecentral.removeItemByIndex(
            this.paymentdetails,
            index
          ))
      );
  }
  /**
   * Add New Payment
   */
  public addUnsavedChange(payment: PaymentDetail, $index: number): void {
    this.setMaintenancejobDeep({
      path: `paymentdetails[${$index}]`,
      data: payment,
    });
  }
}
